<template>
  <div>
    <v-card style="width: 320px;" v-if="show">
      <v-card-title class="justify-center" >
        <v-img v-if="!logo" :src="$root.cdn + 'logo.png'" max-width="180" class="mx-auto mb-1" />
        <v-img v-else :src="logo" max-width="180" class="mx-auto mb-1" />
        Agent Login
      </v-card-title>
      <v-card-text>
        <v-text-field
          v-model="email"
          label="Email"
          outlined
          hide-details
          class="mb-2"
          type="email"
          :disabled="loggingIn"
        />
        <v-text-field
          v-model="password"
          label="Password"
          type="password"
          ref="pwordField"
          id="pwordField"
          outlined
          hide-details
          :disabled="loggingIn"
          @keydown="checkKeypress"
        />
        <div class="text-right my-2">
          <router-link :to="{name: 'auth-forgot'}" style="text-decoration: none;">Forgot Password</router-link>
        </div>
        <div class="text-center mt-4">
          <v-btn color="primary" :loading="loggingIn" @click="login" :disabled="!email || !password">Log In</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'AuthIndex',
  data: () => ({
    email: null,
    password: null,
    loggingIn: false,
    logo:null,
    show:null,
    url:process.env.VUE_APP_API_BASE_URL
  }),
  mounted () {
    if(this.$route.query.e) {
      this.email = this.$route.query.e
      this.$refs.pwordField.focus()
    }
    if(this.$route.params.name){
      this.getLogo(this.$route.params);
    }else{
      this.show = true;
    }
  },
  methods: {
    getLogo(params){
      this.$http.post('auth/partnership-logo', params)
          .then(response => {
            if(response.data && response.data != 'error'){
              this.logo = this.url+'logos/'+response.data;
            }
            if(response.data == 'error'){
              window.location.href = '/'
            }
            this.show = true;
          })
          .catch(err => {
            this.$swal.fire('Error', err.response.data.message, 'error')
          })
    },
    login() {
      this.loggingIn = true
      let params = {
        email: this.email,
        password: this.password
      }

      this.$http.post('auth', params)
        .then(response => {
          if(response.data.user.type != 'AGENT') {
            this.$swal.fire('Access Denied', 'You do not have permission to access this application', 'error')  
          } else {
            this.$store.dispatch('loginUser', response.data)
          }
        })
        .catch(err => {
          this.$swal.fire('Error', err.response.data.message, 'error')
        })
        .finally(() => {
          this.loggingIn = false
        })
    },
    checkKeypress(e) {
      if(e.key == 'Enter') this.login()
    }
  }
}
</script>